import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class ZoneService {
  constructor(private ws: PostmethodService) { }


  createZone(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/zone");
  }

  getZone() {
    return this.ws.wsGet(environment.baseUrl + "masters/zone");
  }

  updateZone(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/zone", id);
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }
}
